import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export interface TaskCounterSubmissionCriteria {
  taskId: number | null;
  taskName: string;
  workDate: string | null;
  from: string | null;
  to: string | null;
  companyId: string;
  jobTitles: string[] | null;
  jobTitleObjects: Array<{ id: string; title: string }>;
  parentCompanyId: string;
  submittedByUserId: string;
}

export interface TaskCounterSubmissionSearchState {
  criteria: TaskCounterSubmissionCriteria;
  page: number;
  pageSize: number;
  hasSearched: boolean;
}

export const defaultTaskCounterSubmissionCriteria: TaskCounterSubmissionCriteria = {
  taskId: null,
  taskName: "",
  workDate: null,
  from: null,
  to: null,
  companyId: "",
  jobTitles: null,
  jobTitleObjects: [],
  parentCompanyId: "",
  submittedByUserId: "",
};

export const defaultTaskCounterSubmissionSearchState: TaskCounterSubmissionSearchState = {
  criteria: defaultTaskCounterSubmissionCriteria,
  page: 0,
  pageSize: 25,
  hasSearched: false,
};

export const taskCounterSubmissionSearchAtom = atom<TaskCounterSubmissionSearchState>({
  key: RecoilKeys.TaskCounterSubmissionSearch,
  default: defaultTaskCounterSubmissionSearchState,
});
